import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';
function getToken() { try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return null; } }
function apiFetch(path) { return fetch(`${API_BASE}${path}`, { headers: { 'x-worker-token': getToken() } }).then(r => r.ok ? r.json() : Promise.reject()); }

// The Employees area — Executive and office only. Add a tile here to grow it.
const TILES = [
  { key: 'list',     label: 'Employee List',      path: '/admin/employees/list',     icon: '👷', color: '#1e3a5f', desc: 'Team members, roles & contact info' },
  { key: 'time-off', label: 'Vacation & Sick Time', path: '/admin/employees/time-off', icon: '🌴', color: '#a16207', desc: 'Requests to approve, sick calls, and vacation vs sick by person and year' },
  { key: 'certs',    label: 'Certifications',     path: '/admin/employees/certifications', icon: '🪪', color: '#0f766e', desc: 'Driver’s licenses, OSHA, CPR, NV Energy gas, traffic control, DOT physicals — review uploads, see what’s expiring' },
];

export default function AdminEmployeeHub() {
  const navigate = useNavigate();
  const [notes, setNotes] = useState({});

  useEffect(() => {
    apiFetch('/users').then(d => { if (Array.isArray(d)) setNotes(n => ({ ...n, list: `${d.filter(u => u.status === 'active').length} active` })); }).catch(() => {});
    apiFetch('/certs/overview').then(d => { if (d && d.people) { const soon = d.people.reduce((n, p) => n + p.certs.filter(c => ['expired', 'red'].includes(c.expiry_state)).length, 0); setNotes(n => ({ ...n, certs: [d.pending.length ? `${d.pending.length} to review` : null, soon ? `${soon} expired or within 30 days` : null].filter(Boolean).join(' · ') || 'All current' })); } }).catch(() => {});
    apiFetch('/time-off?status=pending').then(d => { if (Array.isArray(d)) setNotes(n => ({ ...n, 'time-off': d.length ? `${d.length} waiting for an answer` : 'Nothing waiting' })); }).catch(() => {});
  }, []);

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <button onClick={() => navigate('/admin/administration')} style={{ background: 'none', border: 'none', padding: 0, color: '#6b7280', fontSize: 13, fontWeight: 600, cursor: 'pointer', marginBottom: 4 }}>← Administration</button>
          <h1 className="admin-page-title">Employees</h1>
          <p className="admin-page-sub">The people side of the company — Executive &amp; office only</p>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 16 }}>
        {TILES.map(s => (
          <button key={s.key} onClick={() => navigate(s.path)}
            style={{ textAlign: 'left', background: '#fff', border: '1px solid var(--border)', borderTop: `4px solid ${s.color}`, borderRadius: 12, padding: 20, cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 6, transition: 'box-shadow .15s, transform .1s' }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}>
            <div style={{ fontSize: 30 }}>{s.icon}</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#111827' }}>{s.label}</div>
            <div style={{ fontSize: 12.5, color: '#6b7280', lineHeight: 1.4 }}>{s.desc}</div>
            {notes[s.key] && <div style={{ fontSize: 12, color: s.color, fontWeight: 700, marginTop: 2 }}>{notes[s.key]}</div>}
          </button>
        ))}
      </div>
    </AdminLayout>
  );
}
